import { StringBundle } from '../localizer/stringBundle'

export const strings = {
  bundles: [StringBundle.ATF, StringBundle.BTF],
  strings: [
    'DV_DP_GC_widget_heading',
    'DV_DP_UB_GC_success_message',
    'DV_DP_DV_GCPC_window_title',
    'DV_DP_UB_GC_popup_apply',
    'DV_DP_UB_GC_enter_code',
    'AVOD_DP_GC_promotion_message',
    'DV_DP_GC_balances_explanation',
    'AVOD_DP_GC_toc_learn_more',
    'DV_DP_GC_balance_type_heading',
    'DV_DP_GC_balance_amount_heading',
    'DV_DP_GC_code_input_placeholder',
    'DV_DP_GC_wrong_code',
    'DV_DP_GC_balance_update_failed',
  ] as const,
}
